var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 103,
    viewBox: "0 0 111 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.4992 66.7001H43.1992",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7996 47.1001H82.8996C86.8996 47.1001 90.0996 50.3001 90.0996 54.3001V59.6001C90.0996 63.6001 86.8996 66.8001 82.8996 66.8001H78.0996",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 66.7H23.7C19.7 66.7 16.5 63.5 16.5 59.5V54.2C16.5 50.2 19.7 47 23.7 47H32.7",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6992 47.1001L34.3992 38.4001C35.7992 31.2001 42.0992 26.1001 49.3992 26.1001H67.9992C73.1992 26.1001 77.6992 29.7001 78.8992 34.8001L81.6992 47.2001",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2998 31.8H55.8998V48.6H38.7998L41.4998 37.1C42.2998 34 45.0998 31.8 48.2998 31.8Z",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0996 31.8H62.0996V48.6H76.5996L73.8996 37.1C73.0996 34 70.2996 31.8 67.0996 31.8Z",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 10.8001C110.4 10.8001 108.9 35.6001 88.3998 27.9001C88.3998 27.9001 85.1998 7.70007 110.4 10.8001Z",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.399 15.1001L88.3994 27.9001",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1998 18.3L94.2998 23.4",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104 20.7L99 19.9",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6 27.9001C83.6 26.8001 76.2 22.7001 79.4 7.70007C79.4 7.70007 88.4 9.10007 92.5 14.8001",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0998 1.30005H53.2998V12.5H62.0998V1.30005Z",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2996 7.20002C51.5996 7.00002 49.8996 6.90002 48.1996 6.90002C21.8996 7.00002 0.599609 28.3 0.599609 54.6C0.599609 80.9 21.8996 102.2 48.1996 102.2C71.4996 102.2 90.7996 85.5 94.9996 63.5H89.0996",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0996 4.40002H64.9996",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0996 9.6001H64.9996",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1998 66.7C43.1998 70.7 39.9998 73.9 35.9998 73.9C31.9998 73.9 28.7998 70.7 28.7998 66.7C28.7998 62.7 31.9998 59.5 35.9998 59.5C39.9998 59.5 43.1998 62.7 43.1998 66.7Z",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9 66.7C77.9 70.7 74.7 73.9 70.7 73.9C66.7 73.9 63.5 70.7 63.5 66.7C63.5 62.7 66.7 59.5 70.7 59.5C74.7 59.5 77.9 62.7 77.9 66.7Z",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6994 71C73.0742 71 74.9994 69.0749 74.9994 66.7C74.9994 64.3252 73.0742 62.4 70.6994 62.4C68.3246 62.4 66.3994 64.3252 66.3994 66.7C66.3994 69.0749 68.3246 71 70.6994 71Z",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9992 71C38.374 71 40.2992 69.0749 40.2992 66.7C40.2992 64.3252 38.374 62.4 35.9992 62.4C33.6244 62.4 31.6992 64.3252 31.6992 66.7C31.6992 69.0749 33.6244 71 35.9992 71Z",
    stroke: "#4C9B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.69bb19d2bab6d2a7452237b08392c876.svg";
export { ForwardRef as ReactComponent };